import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Breadcrumb, BreadcrumbsService } from '@vestiaire/api-sdk-angular';
import { RoutingService } from '@app/core/services/routing.service';

@Injectable()
export class BreadcrumbResolver implements Resolve<Breadcrumb[]> {
  constructor(private breadcrumbService: BreadcrumbsService, private routingService: RoutingService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Breadcrumb[]> {
    const url = this.routingService.buildPath(route.root.firstChild.url);

    return this.breadcrumbService.getBreadcrumb(encodeURIComponent(url)).pipe(
      map(res => res.data),
      catchError(err => {
        return of([]);
      })
    );
  }
}
